function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, '__esModule', {
    value: true
});
var React = require('react');
var index_js$1 = require('use-sync-external-store/shim/index.js');
var index_js = require('../_internal/index.js');
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var React__default = /*#__PURE__*/ _interopDefault(React);
// Shared state between server components and client components
var noop = function() {};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = /*#__NOINLINE__*/ noop();
var OBJECT = Object;
var isUndefined = function(v) {
    return v === UNDEFINED;
};
var isFunction = function(v) {
    return typeof v == 'function';
};
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
var getTypeName = function(value) {
    return OBJECT.prototype.toString.call(value);
};
var isObjectTypeName = function(typeName, type) {
    return typeName === "[object ".concat(type, "]");
};
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
var stableHash = function(arg) {
    var type = typeof arg === "undefined" ? "undefined" : _type_of(arg);
    var typeName = getTypeName(arg);
    var isDate = isObjectTypeName(typeName, 'Date');
    var isRegex = isObjectTypeName(typeName, 'RegExp');
    var isPlainObject = isObjectTypeName(typeName, 'Object');
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++){
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while(!isUndefined(index = keys.pop())){
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    } else {
        result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    }
    return result;
};
var serialize = function(key) {
    if (isFunction(key)) {
        try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    var args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : '';
    return [
        key,
        args
    ];
};
var unstable_serialize = function(key) {
    return serialize(key)[0];
};
/// <reference types="react/experimental" />
var use = React__default.default.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
function(thenable) {
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then(function(v) {
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, function(e) {
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
};
var WITH_DEDUPE = {
    dedupe: true
};
var useSWRHandler = function(_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, suspense = config.suspense, fallbackData = config.fallbackData, revalidateOnMount = config.revalidateOnMount, revalidateIfStale = config.revalidateIfStale, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline, keepPreviousData = config.keepPreviousData;
    var _index_js_SWRGlobalState_get = _sliced_to_array(index_js.SWRGlobalState.get(cache), 4), EVENT_REVALIDATORS = _index_js_SWRGlobalState_get[0], MUTATION = _index_js_SWRGlobalState_get[1], FETCH = _index_js_SWRGlobalState_get[2], PRELOAD = _index_js_SWRGlobalState_get[3];
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    var _index_js_serialize = _sliced_to_array(index_js.serialize(_key), 2), key = _index_js_serialize[0], fnArg = _index_js_serialize[1];
    // If it's the initial render of this hook.
    var initialMountedRef = React.useRef(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = React.useRef(false);
    // Refs to keep the key and config.
    var keyRef = React.useRef(key);
    var fetcherRef = React.useRef(fetcher);
    var configRef = React.useRef(config);
    var getConfig = function() {
        return configRef.current;
    };
    var isActive = function() {
        return getConfig().isVisible() && getConfig().isOnline();
    };
    var _index_js_createCacheHelper = _sliced_to_array(index_js.createCacheHelper(cache, key), 4), getCache = _index_js_createCacheHelper[0], setCache = _index_js_createCacheHelper[1], subscribeCache = _index_js_createCacheHelper[2], getInitialCache = _index_js_createCacheHelper[3];
    var stateDependencies = React.useRef({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    var fallback = index_js.isUndefined(fallbackData) ? index_js.isUndefined(config.fallback) ? index_js.UNDEFINED : config.fallback[key] : fallbackData;
    var isEqual = function(prev, current) {
        for(var _ in stateDependencies){
            var t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!index_js.isUndefined(prev[t])) {
                        return false;
                    }
                    if (!compare(returnedData, current[t])) {
                        return false;
                    }
                }
            } else {
                if (current[t] !== prev[t]) {
                    return false;
                }
            }
        }
        return true;
    };
    var getSnapshot = React.useMemo(function() {
        var shouldStartRequest = function() {
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!index_js.isUndefined(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        }();
        // Get the cache and merge it with expected states.
        var getSelectedCache = function(state) {
            // We only select the needed fields from the state.
            var snapshot = index_js.mergeObjects(state);
            delete snapshot._k;
            if (!shouldStartRequest) {
                return snapshot;
            }
            return _object_spread({
                isValidating: true,
                isLoading: true
            }, snapshot);
        };
        var cachedData = getCache();
        var initialData = getInitialCache();
        var clientSnapshot = getSelectedCache(cachedData);
        var serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        var memorizedSnapshot = clientSnapshot;
        return [
            function() {
                var newSnapshot = getSelectedCache(getCache());
                var compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            function() {
                return serverSnapshot;
            }
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    var cached = index_js$1.useSyncExternalStore(React.useCallback(function(callback) {
        return subscribeCache(key, function(current, prev) {
            if (!isEqual(prev, current)) callback();
        });
    }, [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    var isInitialMount = !initialMountedRef.current;
    var hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    var cachedData = cached.data;
    var data = index_js.isUndefined(cachedData) ? fallback && index_js.isPromiseLike(fallback) ? use(fallback) : fallback : cachedData;
    var error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    var laggyDataRef = React.useRef(data);
    var returnedData = keepPreviousData ? index_js.isUndefined(cachedData) ? index_js.isUndefined(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldDoInitialRevalidation = function() {
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !index_js.isUndefined(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !index_js.isUndefined(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return index_js.isUndefined(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return index_js.isUndefined(data) || revalidateIfStale;
    }();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    var defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    var isValidating = index_js.isUndefined(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    var isLoading = index_js.isUndefined(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(revalidateOpts) {
            var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, callbackSafeguard, finalState, finishRequestAndUpdateState, cleanupState, initialState, ref, mutationInfo, cacheData, err, currentConfig, shouldRetryOnError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentFetcher = fetcherRef.current;
                        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) {
                            return [
                                2,
                                false
                            ];
                        }
                        loading = true;
                        opts = revalidateOpts || {};
                        // If there is no ongoing concurrent request, or `dedupe` is not set, a
                        // new request should be initiated.
                        shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ callbackSafeguard = function() {
                            if (index_js.IS_REACT_LEGACY) {
                                return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
                            }
                            return key === keyRef.current;
                        };
                        // The final state object when the request finishes.
                        finalState = {
                            isValidating: false,
                            isLoading: false
                        };
                        finishRequestAndUpdateState = function() {
                            setCache(finalState);
                        };
                        cleanupState = function() {
                            // Check if it's still the same request before deleting it.
                            var requestInfo = FETCH[key];
                            if (requestInfo && requestInfo[1] === startAt) {
                                delete FETCH[key];
                            }
                        };
                        // Start fetching. Change the `isValidating` state, update the cache.
                        initialState = {
                            isValidating: true
                        };
                        // It is in the `isLoading` state, if and only if there is no cached data.
                        // This bypasses fallback data and laggy data.
                        if (index_js.isUndefined(getCache().data)) {
                            initialState.isLoading = true;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (shouldStartNewRequest) {
                            setCache(initialState);
                            // If no cache is being rendered currently (it shows a blank page),
                            // we trigger the loading slow event.
                            if (config.loadingTimeout && index_js.isUndefined(getCache().data)) {
                                setTimeout(function() {
                                    if (loading && callbackSafeguard()) {
                                        getConfig().onLoadingSlow(key, config);
                                    }
                                }, config.loadingTimeout);
                            }
                            // Start the request and save the timestamp.
                            // Key must be truthy if entering here.
                            FETCH[key] = [
                                currentFetcher(fnArg),
                                index_js.getTimestamp()
                            ];
                        }
                        ref = _sliced_to_array(FETCH[key], 2), newData = ref[0], startAt = ref[1], ref;
                        return [
                            4,
                            newData
                        ];
                    case 2:
                        newData = _state.sent();
                        if (shouldStartNewRequest) {
                            // If the request isn't interrupted, clean it up after the
                            // deduplication interval.
                            setTimeout(cleanupState, config.dedupingInterval);
                        }
                        // If there're other ongoing request(s), started after the current one,
                        // we need to ignore the current one to avoid possible race conditions:
                        //   req1------------------>res1        (current one)
                        //        req2---------------->res2
                        // the request that fired later will always be kept.
                        // The timestamp maybe be `undefined` or a number
                        if (!FETCH[key] || FETCH[key][1] !== startAt) {
                            if (shouldStartNewRequest) {
                                if (callbackSafeguard()) {
                                    getConfig().onDiscarded(key);
                                }
                            }
                            return [
                                2,
                                false
                            ];
                        }
                        // Clear error.
                        finalState.error = index_js.UNDEFINED;
                        // If there're other mutations(s), that overlapped with the current revalidation:
                        // case 1:
                        //   req------------------>res
                        //       mutate------>end
                        // case 2:
                        //         req------------>res
                        //   mutate------>end
                        // case 3:
                        //   req------------------>res
                        //       mutate-------...---------->
                        // we have to ignore the revalidation result (res) because it's no longer fresh.
                        // meanwhile, a new revalidation should be triggered when the mutation ends.
                        mutationInfo = MUTATION[key];
                        if (!index_js.isUndefined(mutationInfo) && // case 1
                        (startAt <= mutationInfo[0] || // case 2
                        startAt <= mutationInfo[1] || // case 3
                        mutationInfo[1] === 0)) {
                            finishRequestAndUpdateState();
                            if (shouldStartNewRequest) {
                                if (callbackSafeguard()) {
                                    getConfig().onDiscarded(key);
                                }
                            }
                            return [
                                2,
                                false
                            ];
                        }
                        // Deep compare with the latest state to avoid extra re-renders.
                        // For local state, compare and assign.
                        cacheData = getCache().data;
                        // Since the compare fn could be custom fn
                        // cacheData might be different from newData even when compare fn returns True
                        finalState.data = compare(cacheData, newData) ? cacheData : newData;
                        // Trigger the successful callback if it's the original request.
                        if (shouldStartNewRequest) {
                            if (callbackSafeguard()) {
                                getConfig().onSuccess(newData, key, config);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        cleanupState();
                        currentConfig = getConfig();
                        shouldRetryOnError = currentConfig.shouldRetryOnError;
                        // Not paused, we continue handling the error. Otherwise, discard it.
                        if (!currentConfig.isPaused()) {
                            // Get a new error, don't use deep comparison for errors.
                            finalState.error = err;
                            // Error event and retry logic. Only for the actual request, not
                            // deduped ones.
                            if (shouldStartNewRequest && callbackSafeguard()) {
                                currentConfig.onError(err, key, currentConfig);
                                if (shouldRetryOnError === true || index_js.isFunction(shouldRetryOnError) && shouldRetryOnError(err)) {
                                    if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) {
                                        // If it's inactive, stop. It will auto-revalidate when
                                        // refocusing or reconnecting.
                                        // When retrying, deduplication is always enabled.
                                        currentConfig.onErrorRetry(err, key, currentConfig, function(_opts) {
                                            var revalidators = EVENT_REVALIDATORS[key];
                                            if (revalidators && revalidators[0]) {
                                                revalidators[0](index_js.revalidateEvents.ERROR_REVALIDATE_EVENT, _opts);
                                            }
                                        }, {
                                            retryCount: (opts.retryCount || 0) + 1,
                                            dedupe: true
                                        });
                                    }
                                }
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        // Mark loading as stopped.
                        loading = false;
                        // Update the current hook's state.
                        finishRequestAndUpdateState();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function(revalidateOpts) {
            return _ref.apply(this, arguments);
        };
    }(), // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    var boundMutate = React.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _$_key = 0; _$_key < _len; _$_key++){
            args[_$_key] = arguments[_$_key];
        }
        var _index_js;
        return (_index_js = index_js).internalMutate.apply(_index_js, [
            cache,
            keyRef.current
        ].concat(_to_consumable_array(args)));
    }, []);
    // The logic for updating refs.
    index_js.useIsomorphicLayoutEffect(function() {
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!index_js.isUndefined(cachedData)) {
            laggyDataRef.current = cachedData;
        }
    });
    // After mounted or key changed.
    index_js.useIsomorphicLayoutEffect(function() {
        if (!key) return;
        var softRevalidate = revalidate.bind(index_js.UNDEFINED, WITH_DEDUPE);
        var nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            var initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var onRevalidate = function(type) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (type == index_js.revalidateEvents.FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == index_js.revalidateEvents.RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            } else if (type == index_js.revalidateEvents.MUTATE_EVENT) {
                return revalidate();
            } else if (type == index_js.revalidateEvents.ERROR_REVALIDATE_EVENT) {
                return revalidate(opts);
            }
            return;
        };
        var unsubEvents = index_js.subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            // Performance optimization: if a request is already in progress for this key,
            // skip the revalidation to avoid redundant work
            if (!FETCH[key]) {
                if (index_js.isUndefined(data) || index_js.IS_SERVER) {
                    // Revalidate immediately.
                    softRevalidate();
                } else {
                    // Delay the revalidate if we have data to return so we won't block
                    // rendering.
                    index_js.rAF(softRevalidate);
                }
            }
        }
        return function() {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    index_js.useIsomorphicLayoutEffect(function() {
        var next = function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = index_js.isFunction(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        };
        var execute = function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            } else {
                // Schedule the next interval to check again.
                next();
            }
        };
        var timer;
        next();
        return function() {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    React.useDebugValue(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && index_js.isUndefined(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!index_js.IS_REACT_LEGACY && index_js.IS_SERVER) {
            throw new Error('Fallback data is required when using Suspense in SSR.');
        }
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        var req = PRELOAD[key];
        if (!index_js.isUndefined(req)) {
            var promise = boundMutate(req);
            use(promise);
        }
        if (index_js.isUndefined(error)) {
            var promise1 = revalidate(WITH_DEDUPE);
            if (!index_js.isUndefined(returnedData)) {
                promise1.status = 'fulfilled';
                promise1.value = true;
            }
            use(promise1);
        } else {
            throw error;
        }
    }
    var swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
var SWRConfig = index_js.OBJECT.defineProperty(index_js.SWRConfig, 'defaultValue', {
    value: index_js.defaultConfig
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ var useSWR = index_js.withArgs(useSWRHandler);
// useSWR
Object.defineProperty(exports, "mutate", {
    enumerable: true,
    get: function get() {
        return index_js.mutate;
    }
});
Object.defineProperty(exports, "preload", {
    enumerable: true,
    get: function get() {
        return index_js.preload;
    }
});
Object.defineProperty(exports, "useSWRConfig", {
    enumerable: true,
    get: function get() {
        return index_js.useSWRConfig;
    }
});
exports.SWRConfig = SWRConfig;
exports.default = useSWR;
exports.unstable_serialize = unstable_serialize;
